<a [href]="href()" rel="noopener" target="_blank">
  <app-tile-button [text]="text()" [icon]="icon()"/>
</a>
